module.exports = __webpack_public_path__ + "static/media/chart.3f75a3b3.svg";